import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/error.png';
import _imports_1 from '../../assets/image/link_r.png';
const _withScopeId = n => (_pushScopeId("data-v-e385822e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "tk-platform-box"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "img"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = {
  key: 1,
  class: "tk-platform-box"
};
const _hoisted_7 = {
  class: "withoutImgUrl"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = {
  key: 2,
  class: "tk-danbao"
};
const _hoisted_11 = {
  class: "img"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "text"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "link"
}, "立即访问", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
import { treasure } from '@/utils/https/https';

import { reactive, toRefs, onBeforeMount } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    let data = reactive({
      platforms: [],
      weburl: [],
      withoutImg: [],
      activeIndex: 0
    });
    let {
      platforms,
      weburl,
      activeIndex,
      withoutImg
    } = toRefs(data);
    onBeforeMount(() => {
      treasures(4);
    });
    //接口请求区域
    let treasures = type => {
      let treasures = JSON.parse(sessionStorage.getItem(`platform_${type}`));
      if (treasures == null) {
        treasure({
          type: type
        }).then(res => {
          let datas = res.data.data;
          if (res.data.status == 20000) {
            if (type == 4) {
              data.weburl = datas.haveImg;
              data.withoutImg = datas.withoutImg;
            } else {
              data.platforms = datas;
            }
            sessionStorage.setItem(`platform_${type}`, JSON.stringify(datas));
          }
        });
      } else {
        if (type == 4) {
          data.weburl = treasures.haveImg;
          data.withoutImg = treasures.withoutImg;
        } else {
          data.platforms = treasures;
        }
      }
    };

    //功能区域
    let principalTans = index => {
      if (index == 1) {
        treasures(5);
      }
      data.activeIndex = index;
    };
    let linkTo = url => {
      window.location.href = url;
    };
    return (_ctx, _cache) => {
      const _component_navTabsVue = _resolveComponent("navTabsVue");
      const _component_headNav = _resolveComponent("headNav");
      const _component_van_image = _resolveComponent("van-image");
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_headNav, {
        type: false
      }, {
        tkCont: _withCtx(() => [_createVNode(_component_navTabsVue, {
          nameLeft: "网站大全",
          onPrincipalTans: _unref(principalTans),
          nameRight: "担保平台"
        }, null, 8, ["onPrincipalTans"])]),
        _: 1
      }), !_unref(activeIndex) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weburl), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          onClick: $event => _unref(linkTo)(item.ad_url)
        }, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_van_image, {
          src: item.ad_image
        }, {
          error: _withCtx(() => [_hoisted_4]),
          _: 2
        }, 1032, ["src"])), [[_directive_lazy, item.ad_image]])]), _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1)], 8, _hoisted_2);
      }), 128))])])) : _createCommentVNode("", true), !_unref(activeIndex) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(withoutImg), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: "withoutImg",
          key: index,
          onClick: $event => _unref(linkTo)(item.ad_url)
        }, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1)], 8, _hoisted_8);
      }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(platforms), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("div", _hoisted_11, [_withDirectives((_openBlock(), _createBlock(_component_van_image, {
          src: item.ad_image
        }, {
          error: _withCtx(() => [_hoisted_12]),
          _: 2
        }, 1032, ["src"])), [[_directive_lazy, item.ad_image]])]), _createElementVNode("div", {
          class: "name",
          onClick: $event => _unref(linkTo)(item.ad_url)
        }, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1), _hoisted_15, _hoisted_16], 8, _hoisted_13)]);
      }), 128))])]))], 64);
    };
  }
};